module.exports = __webpack_public_path__ + "img/background_242.fb72e9e5.png";